<template>
 <v-menu
  lazy
  :close-on-content-click="false"
  v-model="menu"
  transition="scale-transition"
  offset-y
  full-width
  :nudge-right="40"
  max-width="290px"
  min-width="290px"
  :disabled=readonly
  >
    <v-text-field
      class="date-field" 
      slot="activator"
      :label="label"
      :value="text"
      v-on:input="updateText"
      v-on:blur="onBlur"
      @keyup.escape.native="resetText(value)"
      :required=required
      :prepend-icon="icon"
      :rules = "rulesMerged"
      :error-messages = "errorMessages" 
      mask = "##.##.####"
      :readonly="readonly || calendarOnly"
      :hint=hint
      :placeholder="placeholder"
      :tabindex="tabindex"
 ></v-text-field>
    <v-date-picker v-model="date" :locale="locale" no-title color="primary" first-day-of-week=1 
      :allowed-dates="allowedDates" :max="max" :min="min"
    >
      <template slot-scope="{ cancel }">
          <v-btn flat color="primary" @click="selectToDay">Сегодня</v-btn>
      </template>
    </v-date-picker>
  </v-menu>
</template>

<script>
  import moment from 'moment'
  export default {
    name: 'date-field',
    props: {
      allowedDates: {
        type: Function,
        default: null
      },
      max: String,
      min: String,
      value: {
        type: String,
        default: null
      },
      hint: {
        type: String,
        default: null
      },
      readonly: {
        type: Boolean,
        default: false
      },
      calendarOnly: {
        type: Boolean,
        default: false
      },
      required: {
        type: Boolean,
        default: false
      },
      resetTextOnBlur: {
        type: Boolean,
        default: false
      },
      rules: {
        type: Array,
        default () {
          return []
        }
      },
      errorMessages: {
        type: Array,
        default () {
          return []
        }
      },
      label: String,
      placeholder: String,
      icon: {
        type: String,
        default: 'event'
      },
      timeMode: Boolean,
      tabindex: 0
    },
    data: function () {
      return {
        menu: null,
        text: null,
        dateRules: {
          required: v => !!v || 'введите дату',
          valid: v => {
            return !v || moment(v, 'DDMMYYYY', true).isValid() || 'дд.мм.гггг - формат даты'
          }
        }
      }
    },
    mounted () {
      this.resetText(this.value)
    },
    watch: {
      value: function (newVal, oldVal) { // watch it
        this.resetText(newVal)
      }
    },
    computed: {
      date: {
        get () {
          var date = this.value ? moment(this.value, moment.ISO_8601) : moment()
          return date.format('YYYY-MM-DD')
        },
        set (value) {
          if (value != null) {
            this.updateValue(value)
          }
        }
      },
      rulesMerged () {
        var result = [this.dateRules.valid]
        if (this.required) {
          result.push(this.dateRules.required)
        }
        result = this.rules.concat(result)
        return result
      },
      locale () {
        return navigator.languages && navigator.languages.length > 0 ? navigator.languages[0] : 'en-en'
      }
    },
    methods: {
      resetText (value) {
        this.text = this.formattedDate(value)
      },
      formattedDate (value) {
        var date = value ? moment(value, moment.ISO_8601) : null
        return date ? date.format('DDMMYYYY') : null
      },
      updateValue: function (value) {
        // console.log('update 1', 'this.value', this.value, 'value: ', value)
        if ((new Date(value)).getTime() !== (new Date(this.value).getTime())) {
          this.$emit('input', value)
        }
        this.menu = false
      },
      updateText: function (value) {
        this.text = value
        // console.log('updateText', 'this.value', this.value, 'value: ', value)
        if (moment(value, 'DDMMYYYY', true).isValid()) {
          this.updateValue(moment(value, 'DDMMYYYY', true).format('YYYY-MM-DD'))
        } else {
          if (!value || value.length === 0) {
            this.updateValue(null)
          }
        }
      },
      selectToDay () {
        this.updateValue(moment().format('YYYY-MM-DD'))
        this.menu = false
      },
      onBlur (e) {
        if (this.resetTextOnBlur) {
          this.resetText(this.value)
        }
      }
    }
  }
</script>

<style>

.date-field.input-group--text-field.input-group--prepend-icon .input-group__details{
  max-width: calc(100% - 24px);
}
.date-field.input-group--text-field.input-group--prepend-icon .input-group__prepend-icon {
  min-width: 36px;  
}
  
</style>


// WEBPACK FOOTER //
// DateField.vue?aa341d3c